export function queryString(params) {
	const pairs = [];
	const keys = Object.keys(params);
	keys.sort();
	keys.forEach(key => {
		if (params[key] === undefined) {
			return;
		}
		pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
	});
	const query = pairs.join('&');
	return query;
}
